<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>工资冲账单说明:</h5><br>
        <span>1、业务说明:以基本工资单为基础，检索相关人员的借款，然后生成对应冲账单数据。再记入相关考勤进行抵扣!</span><br>
        <span>2、操作:先点击<span class="red">生成工资冲账单</span>按钮，然后双击打开明细后，根据需要录入还款金额</span><br>
        <span>3、查询关键字:部门、人员。</span><br>
        <span>4、多次点击会删除<span class="red">未提交</span>的 冲账单。</span><br>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
      <template slot="pre_base_button">
        <button class="pre_btn_ok" @click="fun_build">生成工资冲账单</button>
      </template>

    </pre-base>

  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect,
    Method_Common
  } from '@/utils/loadhttpdata.js';
  export default {
    components: {
      "pre-base": () => import("../auto/old_view_v1.vue")
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: '',
        // 下拉菜单
        // list_fee: [],
        // sel_fee: {},
        element_loading: false,
        show_salary_update: false,
        row_id:0,
        sys_date:'',
        user_name: '',
        s_base: '',
        s_role: '',
        s_butie: '',
        new_base: '',
        new_role: '',
        new_butie: '',
        note: '',
        list_salary_history: []
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init: async function() {

        let t_list_department = [],
          t_list_flag = [],
          t_list_user = [];

        t_list_department = await this.loadClass('data_exp_item_class', '', '', 'dep');

        // t_list_flag = await this.loadClass('data_flag');


        t_list_user = await this.loadClass('data_alluser');

        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": '工资冲账单',
          "control": "salarypay",
          "sel_action": 'exp_salary_pay',
          "upd_action": 'exp15_salary_pay',
          "step": '1',
		  "detail_part":"1",
          "d_sel_action": 'exp_salary_u_d',
          "d_upd_action": 'salary_u_d',
          "file_action": '',
          "p1": '',
          "p2": '',
          "p3": '',
          "parm_sel": [
            {
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long1",
              "sel": "1"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "select",
              "class": "long1",
              "list": t_list_department.data,
              "sel_val": {},
              "sel_name": "",
              "sel": "2"
            },
            {
              "name": "申请人",
              "val": "",
              "key": "u2_name",
              "type": "select",
              "class": "long1",
              "list": t_list_user.data,
              "sel_val": {},
              "sel_name": "",
              "sel": "3"
            }
          ],
          "parm": [
            {
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long1",
              "p": "1",
              "x": "1",
			  "r":"1"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "text",
              "class": "long1",
              "x": "1",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "人员",
              "val": "",
              "key": "u2_name",
              "type": "text",
              "class": "long1",
              "p": "1",
              "x": "1",
			  "r":"1"
            },
            {
              "name": "本期总借款",
              "val": "",
              "key": "amount_all",
              "type": "text",
              "class": "long1",
              "x": "2",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "本期总冲账",
              "val": "",
              "key": "amount_del",
              "type": "text",
              "class": "long1",
              "x": "2",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "本期还款金额",
              "val": "",
              "key": "mount_back",
              "type": "text",
              "class": "long1",
              "x": "2",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "本期剩余待还",
              "val": "",
              "key": "amount_last",
              "type": "text",
              "class": "long1",
              "x": "2",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "本期无需还款",
              "val": "",
              "key": "amount_no",
              "type": "text",
              "class": "long1",
              "x": "2",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "上期剩余待还",
              "val": "",
              "key": "amount_bef",
              "type": "text",
              "class": "long1",
              "x": "3",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "总剩余待还",
              "val": "",
              "key": "pay_all",
              "type": "text",
              "class": "long1",
              "x": "3",
			  "r":"1",
			  "p":"0"
            },
            {
              "name": "备注",
              "val": "",
              "key": "note",
              "type": "text",
              "class": "text",
              "p": "1",
              "x": "4",
			  "r":"1"
            }
          ],
          "parm_th": [{
              "name": "序号"
            },
            {
              "name": "单号"
            },
            {
              "name": "部门"
            },
            {
              "name": "人员姓名"
            },
            {
              "name": "状态"
            },
            {
              "name": "本期总借款(元)"
            },
            {
              "name": "本期总冲账(元)"
            },
            {
              "name": "本期还款(元)"
            },
            {
              "name": "本期剩余待还(元)"
            },
            {
              "name": "本期无需还款(元)"
            },
            {
              "name": "上期剩余待还(元)"
            },
            {
              "name": "总剩余待还(元)"
            },
            {
              "name": "备注"
            },
            {
              "name": "录入人"
            },
            {
              "name": "更新时间"
            }
          ],
          "d_parm": [
            {
                "name": "单号",
                "val": "",
                "key": "sheet_no",
                "type": "none",
                "w": "1",
                "p": "1"
              },
              {
                "name": "名称",
                "val": "",
                "key": "pay_name",
                "type": "text",
                "class": "long1",
                "p": "1"
              },
              {
                "name": "金额",
                "val": "",
                "key": "pay_amount",
                "type": "number",
                "class": "long1",
                "p": "1"
              },
              {
                "name": "类型",
                "val": "",
                "key": "pay_io",
                "type": "select",
                // "slot": "slot_c_out_fee",
                "list":[{"id":"2","val":"还款"},{"id":"3","val":"取消还款"}],
                "sel_name": "",
                "sel_val":{},
                "class": "long1",
                "p": "1"
              },
              {
                "name": "备注",
                "val": "",
                "key": "note",
                "type": "text",
                "class": "long3",
                "p": "1"
              }
          ],
          "d_name": [
            {
              "name": "ID"
            },
            {
              "name": "序号"
            },
            {
              "name": "单号"
            },
            {
              "name": "借款单号"
            },
            {
              "name": "费用名称"
            },
            {
              "name": "费用金额"
            },
            {
              "name": "费用类型"
            },
            {
              "name": "备注"
            },
            {
              "name": "录入人"
            },
            {
              "name": "更新时间"
            }
          ]
        });

      },
      refresh_data: function(type,page) {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data(type,page);
        });
      },
      refresh_father: function(type, val, parm) {
        console.log('type=' + type + ' val=' + val);

        if (this.show_salary_update) {
          this.fun_base_history();
        }

        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
          default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      },
      loadClass: function(action, p1, p2, p3) {
        let that = this;
        return new Promise((resolve, reject) => {
          // console.log(menuvalue);
          that.$post(
            api.http_method, Method_EasySelect(action, p1, p2, p3)
          ).then(res => {
            res = JSON.parse(res);
            // console.log(res.data);
            resolve(res.data)
          });

        });
      },
      fun_build: function() {
        this.element_loading = true;
        let d=[];
        this.$post(
          api.http_method, Method_Common('data_salary_pay_build',0,'',d)
        ).then(res => {
          res = JSON.parse(res);
          console.log(res.data);
          this.element_loading = false;
          if (res.data.status == '1') {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.refresh_data('',1);
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });

      }



    }
  };
</script>
<style scoped="scoped">
  .top_sheetno {
    position: absolute;
    top: 16%;
    left: 10%;
    background-color: rgba(0, 0, 0, 0.5);
    /* opacity: 0.2; */
    /* border: 1px solid black; */
    /* padding-left: 20px; */
    /* padding-right: 20px; */
    border-radius: 5px;
    z-index: 3;
    width: 80%;
    text-align: center;
    padding: 20px;
    overflow-x: auto;
  }

  .top_sheetno_close>img {
    width: 24px;
    height: auto;
    position: absolute;
    right: 24px;
    top: 24px;
    cursor: pointer;
  }

  .salary {
    padding-bottom: 20px;
  }

  .salary>div {
    margin-top: 10px;
  }

  .salary-edit {
    display: inline-block;
    width: 100%;
  }

  .salary-edit>label {
    display: inline-block;
    width: 108px;
  }
</style>
